'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AllFilesQuery = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _bson = require('bson');

var _lodash = require('lodash');

var _SystemNode2 = require('../abstract/SystemNode');

var _SystemNode3 = _interopRequireDefault(_SystemNode2);

var _BinderQuery = require('./BinderQuery');

var _BinderQuery2 = _interopRequireDefault(_BinderQuery);

var _SecurityClause = require('../security/SecurityClause');

var _SecurityClause2 = _interopRequireDefault(_SecurityClause);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllFilesQuery = exports.AllFilesQuery = function (_SystemNode) {
    (0, _inherits3.default)(AllFilesQuery, _SystemNode);

    function AllFilesQuery() {
        var _ref;

        (0, _classCallCheck3.default)(this, AllFilesQuery);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AllFilesQuery.__proto__ || (0, _getPrototypeOf2.default)(AllFilesQuery)).call.apply(_ref, [this].concat(args)));

        _this._documentIds = [];
        return _this;
    }

    (0, _createClass3.default)(AllFilesQuery, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            var aggregate = this.children.reduce(function (conditions, child) {
                var qf = child.toQueryFragment();
                if (qf) {
                    conditions.push(qf);
                }
                return conditions;
            }, []);

            if (!(0, _lodash.isEmpty)(this.documentIds)) {
                var documentObjectIds = this.documentIds.map(function (docId) {
                    return new _bson.ObjectId(docId);
                });
                return { $and: [{ $or: aggregate }, { '_id': { $in: documentObjectIds } }] };
            }
            return { $or: aggregate };
        }
    }, {
        key: 'documentIds',
        get: function get() {
            return this._documentIds;
        },
        set: function set(ids) {
            this._documentIds = ids;
        }
    }]);
    return AllFilesQuery;
}(_SystemNode3.default);

AllFilesQuery.accepts = [_BinderQuery2.default, _SecurityClause2.default];
AllFilesQuery.canHaveChildren = true;
AllFilesQuery.terminalNode = false;
AllFilesQuery.displayName = 'All Files Query';

_QueryNodeRegistry2.default.register(AllFilesQuery);
exports.default = AllFilesQuery;